import { render, staticRenderFns } from "./dataFind.vue?vue&type=template&id=2b3557c6&scoped=true&"
import script from "./dataFind.vue?vue&type=script&lang=js&"
export * from "./dataFind.vue?vue&type=script&lang=js&"
import style0 from "./dataFind.vue?vue&type=style&index=0&id=2b3557c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3557c6",
  null
  
)

export default component.exports